import React from "react";
import {Scorebar} from "./Scorebar";

const ProductPreviewItem = ({product, scoreType, imagesBaseUrl}) => {
  const scoreLabel = {
    supScore: 'Gesamtbewertung:',
    bioScore: 'Bioberfügbarkeit:',
    qualityScore: 'Qualität:',
  }[scoreType] || '?';

  return (
    <div className="product-preview-tile">
      <a href={`/produkt/${product.id}/${product.urlName}`}>
        <div className="product-preview-img-container">
          <img
            src={`${imagesBaseUrl}/${product.imageNameShort}/${product.urlName}.webp?h=180`}
            alt={product.name}
          />
        </div>
        <div className="product-preview-tile-title">{product.name}</div>
      </a>
      <div className="product-preview-tile-availability">{scoreLabel}</div>

      <Scorebar product={product} scoreType={scoreType} height="16px" width="170px"/>
    </div>
  );
};
export default ProductPreviewItem;
